/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./GameMiniRecord.vue?vue&type=template&id=12006d54&scoped=true"
import script from "./GameMiniRecord.vue?vue&type=script&lang=js"
export * from "./GameMiniRecord.vue?vue&type=script&lang=js"
import style0 from "./GameMiniRecord.vue?vue&type=style&index=0&id=12006d54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12006d54",
  null
  
)

export default component.exports